module.exports = __webpack_public_path__ + "fonts/PingFangSC-Regular.75225b29.ttf";